"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YDMIFormat = exports.DistanceFormat = exports.formatNumber = exports.isEN = exports.getNumberPattern = exports.getBaseInfo = exports.getDistancePattern = exports.initBase = void 0;
var __1 = require("..");
var constants_1 = require("../utils/constants");
function initBase() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ''];
        });
    });
}
exports.initBase = initBase;
/**
 * 确定业务方是否初始化了local信息
 * @return {void}
 */
function ensureLocaleExists() {
    if (!__1.Config.locale) {
        throw Error('Elvish Error: please call init function with local parameter first');
    }
}
/**
 * 获取apollo的配置值
 * @return {any}
 */
function getApolloValue(key, defaultValue) {
    var _a, _b;
    try {
        return ((_a = __1.Config.apollo) === null || _a === void 0 ? void 0 : _a[key][__1.Config.locale]) || defaultValue || ((_b = __1.Config.apollo) === null || _b === void 0 ? void 0 : _b[key].default);
    }
    catch (e) {
        return defaultValue;
    }
}
/**
 * 获取距离pattern
 * @return {Record<any, any>}
 */
function getDistancePattern() {
    ensureLocaleExists();
    return getApolloValue(constants_1.ApolloKey.DISTANCE, undefined);
}
exports.getDistancePattern = getDistancePattern;
/**
 * 获取初始化配置
 * @return {Record<any, any>}
 */
function getBaseInfo() {
    ensureLocaleExists();
    return {
        locale: __1.Config.locale
    };
}
exports.getBaseInfo = getBaseInfo;
/**
 * 获取数字pattern
 * @return {Record<any, any>}
 */
function getNumberPattern() {
    ensureLocaleExists();
    return getApolloValue(constants_1.ApolloKey.NUMBERV2, undefined);
}
exports.getNumberPattern = getNumberPattern;
/**
 * 是否是英制国家
 * @return {boolean}
 */
function isEN(country) {
    var _a, _b, _c;
    var countryFromLocal = __1.Config.locale.toUpperCase().match(/[A-Z]{2}$/);
    if (!countryFromLocal) {
        throw Error('Elvish Error: local is not valid');
    }
    return ~((_c = (_b = (_a = __1.Config.apollo) === null || _a === void 0 ? void 0 : _a[constants_1.ApolloKey.IMPERIAL]) === null || _b === void 0 ? void 0 : _b.countries) === null || _c === void 0 ? void 0 : _c.indexOf(country || __1.Config.country || countryFromLocal[0]));
}
exports.isEN = isEN;
/**
 * 格式化数字
 * @return {string}
 */
function formatNumber(number, decimalsLength, numberPattern) {
    var _a, _b;
    // @ts-ignore
    var numberString = (_b = (((_a = number === null || number === void 0 ? void 0 : number.toFixed) === null || _a === void 0 ? void 0 : _a.call(number, decimalsLength)) - 0)) === null || _b === void 0 ? void 0 : _b.toLocaleString('en-US');
    if (numberPattern && numberPattern.group)
        numberString = numberString.replace(',', numberPattern.group);
    if (numberPattern && numberPattern.decimal && decimalsLength) {
        var reg = new RegExp("\\.(\\d{".concat(decimalsLength, "})$"));
        numberString = numberString.replace(reg, "".concat(numberPattern.decimal, "$1"));
    }
    return numberString;
}
exports.formatNumber = formatNumber;
var DistanceFormat = /** @class */ (function () {
    function DistanceFormat(number, unit) {
        this.distancePattern = getDistancePattern();
        this.number = Number(number);
        this.unit = unit;
        this.initUnit();
    }
    DistanceFormat.prototype.initUnit = function () {
        var unit = this.number > this.distancePattern.m_threshold
            ? constants_1.UnitMap.DISTANCE_KILOMETER
            : constants_1.UnitMap.DISTANCE_METER;
        // @ts-ignore
        this.curUnit = constants_1.UnitMap[this.unit] || unit;
        // @ts-ignore
        this.originUnit = constants_1.UnitMap[this.unit] || unit;
        // @ts-ignore
        if (isEN()) {
            this.curUnit = constants_1.InitUnitMap.MILE;
        }
        else if ([constants_1.InitUnitMap.MILE, constants_1.InitUnitMap.LOCAL].includes(this.curUnit)) {
            this.curUnit = unit;
        }
    };
    DistanceFormat.prototype.getCurUnit = function () {
        return this.curUnit;
    };
    DistanceFormat.prototype.getOriginUnit = function () {
        return this.originUnit;
    };
    DistanceFormat.prototype.getUnit = function () {
        return this.unit;
    };
    DistanceFormat.prototype.getNumber = function () {
        if (this.curUnit === constants_1.UnitMap.DISTANCE_KILOMETER) {
            return this.number / 1000;
        }
        return this.number;
    };
    DistanceFormat.prototype.getDistancePattern = function () {
        return this.distancePattern;
    };
    DistanceFormat.prototype.setNumber = function (number) {
        return (this.number = number);
    };
    DistanceFormat.prototype.pattern = function (numberformat, isHighLight) {
        // @ts-ignore
        return this.distancePattern[isHighLight ? "h".concat(this.curUnit) : this.curUnit].replace(/[#,.0]+/, numberformat);
    };
    return DistanceFormat;
}());
exports.DistanceFormat = DistanceFormat;
var YDMIFormat = /** @class */ (function (_super) {
    __extends(YDMIFormat, _super);
    function YDMIFormat(number, unit) {
        var _this = _super.call(this, number, unit) || this;
        _this.initNmber();
        return _this;
    }
    YDMIFormat.prototype.initNmber = function () {
        // @ts-ignore
        if (this.getNumber() <= constants_1.MILE_TO_METERS && constants_1.InitUnitMap.MILE !== this.getOriginUnit()) {
            this.setNumber(this.getNumber() / constants_1.MILE_TO_YARD);
            this.yd = constants_1.InitUnitMap.YD;
        }
        else {
            this.setNumber(this.getNumber() * constants_1.MILE_TO_KILOMETERS);
        }
    };
    YDMIFormat.prototype.pattern = function (numberformat, isHighLight) {
        var _a;
        return (_a = this.getDistancePattern()) === null || _a === void 0 ? void 0 : _a[isHighLight ? "h".concat(this.getCurUnit()) : this.getCurUnit()].replace(/[#,.0]+/, numberformat).replace(this.yd ? 'mi' : '', this.yd || '');
    };
    return YDMIFormat;
}(DistanceFormat));
exports.YDMIFormat = YDMIFormat;
